<template>
    <!-- Alternative Sidebar -->
    <div id="sidebar-alt" tabindex="-1" aria-hidden="true">
        <!-- Toggle Alternative Sidebar Button (visible only in static layout)
        --> <a href="javascript:void(0)" id="sidebar-alt-close" onclick="App.sidebar(&apos;toggle-sidebar-alt&apos;);"><i class="fa fa-times"></i></a>
        <!--
        Wrapper for scrolling functionality -->
        <div id="sidebar-scroll-alt">
            <!-- Sidebar Content -->
            <div class="sidebar-content">
                <!-- Profile -->
                <div class="sidebar-section">
                        <h2 class="text-light">Perfil</h2>
                    <form action="index.html" method="post" class="form-control-borderless"
                    onsubmit="return false;">
                        <div class="form-group">
                            <label for="side-profile-name">Nombre</label>
                            <input type="text" id="side-profile-name" name="side-profile-name"
                            class="form-control" value="Pepito P&#xE9;rez">
                        </div>
                        <div class="form-group">
                            <label for="side-profile-email">Email</label>
                            <input type="email" id="side-profile-email" name="side-profile-email"
                            class="form-control" value="pepitop@ejemplo.com">
                        </div>
                        <div class="form-group">
                            <label for="side-profile-password">Nueva Contrase&#xF1;a</label>
                            <input type="password" id="side-profile-password"
                            name="side-profile-password" class="form-control">
                        </div>
                        <div class="form-group">
                            <label for="side-profile-password-confirm">Confirmar Nueva Contrase&#xF1;a</label>
                            <input type="password" id="side-profile-password-confirm"
                            name="side-profile-password-confirm" class="form-control">
                        </div>
                        <div class="form-group remove-margin">
                            <button type="submit" class="btn btn-effect-ripple btn-primary" onclick="App.sidebar(&apos;close-sidebar-alt&apos;);">Guardar</button>
                        </div>
                    </form>
                </div>
                <!-- END Profile -->
                <!-- Settings -->
                <div class="sidebar-section">
                        <h2 class="text-light">Ajustes</h2>
                    <form action="index.html" method="post" class=" form-control-borderless"
                    onsubmit="return false;">
                        <div class="form-group">
                            <label class="col-7 col-form-label-fixed">Notificaciones</label>
                            <div class="col-5">
                                <label class="switch switch-success">
                                    <input type="checkbox" checked><span></span>
                                </label>
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="col-7 col-form-label-fixed">Perfil P&#xFA;blico</label>
                            <div class="col-5">
                                <label class="switch switch-success">
                                    <input type="checkbox" checked><span></span>
                                </label>
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="col-7 col-form-label-fixed">Enable API</label>
                            <div class="col-5">
                                <label class="switch switch-success">
                                    <input type="checkbox"><span></span>
                                </label>
                            </div>
                        </div>
                        <div class="form-group remove-margin">
                            <button type="submit" class="btn btn-effect-ripple btn-primary" onclick="App.sidebar(&apos;close-sidebar-alt&apos;);">Guardar</button>
                        </div>
                    </form>
                </div>
                <!-- END Settings -->
            </div>
            <!-- END Sidebar Content -->
        </div>
        <!-- END Wrapper for scrolling functionality -->
    </div>
    <!-- END Alternative Sidebar -->
</template>
<script>
export default {

}
</script>

